// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ScenarioLayer
 */
export interface ScenarioLayer {
  /**
   *
   */
  id?: string | null;
  /**
   *
   */
  name: string;
  /**
   *
   */
  code: string;
  /**
   *
   */
  label?: string | null;
}

/**
 * Check if a given object implements the ScenarioLayer interface.
 */
export function instanceOfScenarioLayer(value: object): value is ScenarioLayer {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("code" in value) || value["code"] === undefined) return false;
  return true;
}

export function ScenarioLayerFromJSON(json: any): ScenarioLayer {
  return ScenarioLayerFromJSONTyped(json, false);
}

export function ScenarioLayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScenarioLayer {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] === undefined ? undefined : json["id"] === null ? null : json["id"],
    name: json["name"],
    code: json["code"],
    label: json["label"] === undefined ? undefined : json["label"] === null ? null : json["label"],
  };
}

export function ScenarioLayerToJSON(json: any): ScenarioLayer {
  return ScenarioLayerToJSONTyped(json, false);
}

export function ScenarioLayerToJSONTyped(
  value?: ScenarioLayer | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    name: value["name"],
    code: value["code"],
    label: value["label"],
  };
}
